import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { jwtDecode } from 'jwt-decode';
import { GET_USER_PROFILE } from './common/graphql/queries';
import { DecodedSSOToken } from './common/models/decodedSsoToken';
import { CommonserviceService } from './common/services/commonservice.service';
import { DataService } from './common/services/data.service';
import { ErrorHandlerComponent } from './common/components/error-handler/error-handler.component';
import { ErrorHandlerService } from './common/services/error-handler.service';
import { SpinnerService } from './common/services/spinner.service';
import { userApplConfigSignal, userDetailsSignal, userRoleMapngSignal } from './common/signals/user-profile-signal';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  @ViewChild('errorMessage') errorMessage: ErrorHandlerComponent;
  title = 'HCM Lineside';
  public showHeaderAndFooter: boolean = false;
  ssoUserDetails: DecodedSSOToken;
  namc: string = '';
  role: string = '';
  newUser: boolean = false;
  isLoading: boolean = false;
  errorList: string[] = [];
  constructor(private readonly router: Router,private msalService: MsalService,
    private readonly commonService: CommonserviceService,
    private readonly dataService: DataService,
    private readonly errorService: ErrorHandlerService,
    private readonly spinner: SpinnerService
  ) {
  }

  ngOnInit(): void {
    this.initializeApp();
  }

  private initializeApp(): void {
    this.getPikeToken()
    this.msalService.instance.initialize().then(() => {
      if (this.msalService.instance.getAllAccounts().length > 0) {
        this.handleExistingSession();
      } else {
        this.handleNewSession();
      }
    }).catch((error) => {
      console.error('MSAL initialization failed:', error);
    });
  }

  private handleExistingSession(): void {
    this.showHeaderAndFooter = true;
    const ssoUserDetailsString = sessionStorage.getItem('ssoUserDetails');
    if (ssoUserDetailsString) {
      this.ssoUserDetails = JSON.parse(ssoUserDetailsString) as DecodedSSOToken;
      this.setProfileDetails();
      this.getUserProfile();
    }
  }

  private handleNewSession(): void {
    this.msalService.instance.handleRedirectPromise().then((response) => {
      if (response) {
        const idToken = response.idToken;
        const decodedTMNAToken: any = jwtDecode(idToken);
        sessionStorage.setItem('ssoUserDetails', JSON.stringify(decodedTMNAToken));
        const ssoUserDetailsString = sessionStorage.getItem('ssoUserDetails');
        if (ssoUserDetailsString) {
          this.ssoUserDetails = JSON.parse(ssoUserDetailsString) as DecodedSSOToken;
          this.setProfileDetails();
          this.getUserProfile();
          this.showHeaderAndFooter = true;
        }
      }
    }).catch((error) => {
      console.error('Error handling redirect promise:', error);
    });
  }

  private setProfileDetails(): void {
    if (this.ssoUserDetails) {
      const roles = this.ssoUserDetails.roles;
      if (roles && roles.length > 0) {
      const roleParts = roles[0].split('.');
      if (roleParts.length >= 3) {
        this.namc = roleParts[1];
        this.role = roleParts[2];
      }
        }}
      const ssoUserDtls = {
        ToyotaGUID: this.ssoUserDetails?.ToyotaGUID,
        WorkdayID: this.ssoUserDetails?.WorkdayID,
        roles: this.role,
        namc: this.namc
      }
      
      this.commonService.setNamc(this.namc);
      this.commonService.setRoles(this.role);
      this.dataService.setUserId(this.ssoUserDetails?.WorkdayID);
   }

  private getUserProfile(): void {
    this.spinner.show();
    const userId = this.ssoUserDetails?.ToyotaGUID;
    this.commonService.getHcmData(GET_USER_PROFILE, { userId }).subscribe({
      next: (response) => this.handleUserProfileResponse(response),
      error: (error) => this.handleUserProfileError(error),
      complete: () => this.spinner.hide()
    });
  }

  private handleUserProfileResponse(response: any): void {
    if (response?.data?.getUserProfile?.userProfile?.userId) {
      this.newUser = false;
        const userApplConfig = {
        plantName: response.data.getUserProfile.userProfile.plantName,
        shopName: response.data.getUserProfile.userProfile.shopName,
        lineName: response.data.getUserProfile.userProfile.lineName,
        // userId: response.data.getUserProfile.userProfile.userId,
        // namc: response.data.getUserProfile.userProfile.namc,
        // title: response.data.getUserProfile.userProfile.title

      };
      this.dataService.setUserProfile(response.data.getUserProfile.userProfile);
      this.dataService.setUserPreferences(userApplConfig);
      userApplConfigSignal.update(currentValue => ({ ...currentValue, ...userApplConfig }));
      this.router.navigate(['/home']);
    } else {
      this.newUser = true;
      this.spinner.hide();
      this.router.navigate(['/save-user-profile']);
    }

    if (response?.data?.getUserProfile?.userRoleMapping) {
      const userRoleMapng = {
        userRoleId: response.data.getUserProfile.userRoleMapping.userRoleId,
        userId: response.data.getUserProfile.userRoleMapping.userId,
      }
      userRoleMapngSignal.update(currentValue => ({ ...currentValue, ...userRoleMapng }));
      this.dataService.setUserRoleId(response.data.getUserProfile.userRoleMapping.userRoleId);
    } else {
      this.spinner.hide();
      this.errorService.setErrorMessage(['No Roles assigned to the user, please contact the admin']);
      this.router.navigate(['/home']);
    }

    if (response?.data?.getUserProfile?.userWorkDay) {
      const ssoUserDetails = {
        userId: response?.data?.getUserProfile?.userWorkDay?.userId,
        workDayId: response?.data?.getUserProfile?.userWorkDay?.workDayId,
        firstName: response?.data?.getUserProfile?.userWorkDay?.firstName,
      }
      userDetailsSignal.update(currentValue => ({ ...currentValue, ...ssoUserDetails }));
      this.dataService.setWorkDayId(response.data.getUserProfile.userWorkDay.workDayId);
    }
    
  }

  private handleUserProfileError(error: any): void {
    this.spinner.hide();
    this.router.navigate(['/home']);
    this.errorService.setErrorMessage([]);
  }

  private getPikeToken(): void {
    this.commonService.getPieToken().subscribe({
      next: (response) => {
        this.dataService.setPieToken(response?.accessToken);
      },
      error: (error) => {
        console.error('Erro fetching Pie Token:', error);
      }
    });
  }
    
}
